import { render, staticRenderFns } from "./topbar-2.vue?vue&type=template&id=14a0b8a4"
import script from "./topbar-2.vue?vue&type=script&lang=js"
export * from "./topbar-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/topbar/topbar-2.vue
// module id = kZ0O
// module chunks = 0